import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import Cookie from '@/util/cookie'
Vue.use(VueAxios,axios);
	// let token = ''
	// if(window.sessionStorage.getItem('token')){
	// 	token =window.sessionStorage.getItem('token_type') + ' ' + window.sessionStorage.getItem('token')
	// }
	// console.log(token,1)
const requests = axios.create({
  timeout: 100000,
  
  baseURL: 'https://pc.jnxsd.top/api/m15414',  // 正式
  // baseURL: 'https://yufabu.saizhuge.net/api/m15414', //测试
  
  headers: {
    // 'content-type':  'application/json;charset=UTF-8;',
	 'Content-Type': 'application/json;charset=UTF-8;'
	// 'authorization': token
    // 'content-type':  'application/x-www-form-urlencoded'
  }
})

requests.interceptors.request.use((config) => {
	// if(config.url == 'user/login' || config.url == 'sms/aliSend' || config.url == 'user/mobileLogin'){
	// 	let a = {
	// 		'content-type':  'application/x-www-form-urlencoded',
	// 	}
	// 	config.headers = Object.assign({}, a)
	// }
	let token = ''
	if(window.sessionStorage.getItem('token')){
		// console.log(window.sessionStorage.getItem('token'),111111)
		// token =window.sessionStorage.getItem('token_type') + ' ' + window.sessionStorage.getItem('token')
		config.headers['user-token'] = window.sessionStorage.getItem('token');
	}
	console.log(window.sessionStorage.getItem('token'),2)
  // config.headers['Authorization'] =1234;
  return config;
})
console.log(requests,11111111111)
requests.interceptors.response.use((res) => {

  if(res.data.code == '-201' || res.data.code == '-202' || res.data.code == '-203' || res.data.code == '5' ){
	  window.sessionStorage.setItem('token', '');
	  window.sessionStorage.setItem('user','');
    // window.location.href = 'https://app.annengyunshu.com/pc/#/login';
	this.$router.push({
		name: 'login',
		// params: page,
	});
    return Promise.reject(res.data);
  }else{
    return res.data;
  }
}, (error) => {
  return Promise.reject(error)
})

export default requests;